// extracted by mini-css-extract-plugin
export default {"nav":"navbar_nav__IsQmn","titulo":"navbar_titulo__dupgg","lista":"navbar_lista__J+Ek1","links":"navbar_links__3fJ3v","icon":"navbar_icon__7MSt6"};